__turbopack_context__.v({
  "passport_thumbnail_carousel": "PassportThumbnailCarousel-module-scss-module__NYjA0W__passport_thumbnail_carousel",
  "splide__arrow": "PassportThumbnailCarousel-module-scss-module__NYjA0W__splide__arrow",
});
